import React, { useState, forwardRef } from "react";
import PropTypes from "prop-types";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const AlertComponent = forwardRef(function AlertComponent(props, ref) {
  return <Alert elevation={6} variant="filled" ref={ref} {...props} />;
});

const ErrorMessage = ({ message, statusCode }) => {
  const [open, setOpen] = useState(!!message && statusCode !== 401);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  
  if (statusCode === 401) {
    globalThis.location.reload();
  }
  
  return (
    <Snackbar 
      open={open} 
      autoHideDuration={6000} 
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <AlertComponent
        sx={{ backgroundColor: "rgba(0, 102, 255, 1)" }}
        onClose={handleClose}
        severity="info"
      >
        {message}
      </AlertComponent>
    </Snackbar>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
  statusCode: PropTypes.number,
};

export default ErrorMessage;
